import { useEffect, useState } from "react";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { Form, Input } from "antd";
import style from "./style.module.scss";
import { StorageService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import { SimpleInput } from "../../../../common/components/simpleInput/SimpleInput";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../../utilities/API_URLs";
import { DynamicUploadFile } from "../../../../common/components/Upload/DynamicUploadFile";

type CustomerRemovalFormType = {
  onFinish: () => void;
  initialValue?: any;
};

const CustomerRemovalForm = ({ onFinish, initialValue }: CustomerRemovalFormType) => {
  const [form] = Form.useForm();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        destination: values.destination.value,
        deliveryNote: values.deliveryNote.value,
        ...(initialValue
          ? {
              id: initialValue?.["@id"].split("/").pop()
            }
          : {}),
      };

      
        const res = await StorageService.updateStorageLoad(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Client"
                name={"destination"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<InputSelect uri={API_URLs.settings.customers.getCustomerSelect} onChange={(e)=>console.log(e)} />}
              />
            </div>
          </div>
          <div className={style.form__item_wrapper}>
            <div className='mt-4'>
              <SimpleInput
                Form={Form}
                label="Pièce jointe"
                name={"deliveryNote"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <DynamicUploadFile form={form} name="deliveryNote" />
                }
              />
            </div>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", marginTop: "1rem"}}>
  <CustomButton
    type="submit"
    className={style.form__action_button}
    isLoading={isLoadingSubmit}
  >
    Envoyer
  </CustomButton>
</div>

      </FormProvider>
    </div>
  );
};

export default CustomerRemovalForm;
